import UnlockLinkInfoModalComponent from "./UnlockLinkInfoModalComponent";

export default UnlockLinkInfoModalComponent;
